export default __webpack_public_path__ + "4d81ee51fa2520df58ae092aeb3d0bd4.svg";